import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TypeUser } from '@core/utils/functions/typeUser.function';

const ADMIN = 'admin';
const CLIENT = 'client';

export const typeUserGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const userCodi = localStorage.getItem('user_code');
  const userJson = userCodi ? JSON.parse(atob(userCodi)) : null;

  //const rutaClient = router.url.includes('client/');
  const rutaAdmin = route.routeConfig?.title == 'admin';
  
  const typeUser = (type:string) => { return TypeUser(type, state.url) };
  
  const falseReturn = (user_type:string) => {
    // router.navigate(['/login']);
    // Guardar la URL a la que intentaba acceder un usuario tipo admin o client
    router.navigate((user_type == ADMIN && rutaAdmin) ? ['/admin/dashboard'] : ['/client/dashboard'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if(typeUser(userJson.user_type)){
    return true;
  }else{
    return falseReturn(userJson.user_type);
  }
};
